(function () {
  'use strict';

  function settings() {
    return window.neovaCartSettings || {};
  }

  function dispatchCartRefresh() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  async function fetchCart() {
    const res = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    return res.json();
  }

  async function addToCart(variantId, isGift, giftType) {
    const item = { id: variantId, quantity: 1 };
    if (isGift) {
      item.properties = { Gift: giftType };
    }
    const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] }),
    });
    return res.json();
  }

  async function removeFromCart(variantId) {
    const res = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: { [variantId]: 0 } }),
    });
    return res.json();
  }

  document.addEventListener('click', async function (evt) {
    const giftBtn = evt.target.closest('.neova-gift-add');
    const bestSellerBtn = evt.target.closest('.neova-best-seller-add');
    if (!giftBtn && !bestSellerBtn) return;

    const btn = giftBtn || bestSellerBtn;
    if (btn.disabled) return;

    evt.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-loading');

    try {
      const variantId = parseInt(btn.dataset.variantId, 10);
      if (giftBtn) {
        await addToCart(variantId, true, 'Free');
      } else {
        await addToCart(variantId, false);
      }
      dispatchCartRefresh();
    } catch (e) {
      console.error('[neova-cart] add failed', e);
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  });

  let cartLogicRunning = false;

  async function runCartGiftLogic() {
    const s = settings();
    if (cartLogicRunning) return;
    cartLogicRunning = true;

    try {
      const cart = await fetchCart();
      const totalPrice = cart.total_price;

      // --- 1. Auto-remove carousel-picked gifts (property Gift: Free) when cart drops below free gift threshold
      if (s.freeGiftThreshold && totalPrice < s.freeGiftThreshold) {
        const carouselGifts = cart.items.filter(function (i) {
          return i.properties && i.properties.Gift === 'Free';
        });
        if (carouselGifts.length > 0) {
          const updates = {};
          for (const g of carouselGifts) {
            updates[g.key] = 0;
          }
          await fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates }),
          });
          dispatchCartRefresh();
          return;
        }
      }

      // --- 2. Auto-gift (add/remove) keyed to autoGiftThreshold
      if (!s.autoGiftVariantId || !s.autoGiftThreshold) return;

      const giftLine = cart.items.find(function (i) {
        return i.variant_id === s.autoGiftVariantId;
      });
      const removedFlag = sessionStorage.getItem('neova-autogift-removed-' + s.autoGiftVariantId);

      if (totalPrice >= s.autoGiftThreshold) {
        const nonGiftItems = cart.items.filter(function (i) {
          return !(i.properties && i.properties.Gift);
        });
        if (!giftLine && !removedFlag && nonGiftItems.length > 0) {
          await addToCart(s.autoGiftVariantId, true, 'Gift');
          dispatchCartRefresh();
        }
      } else if (giftLine) {
        await removeFromCart(s.autoGiftVariantId);
        sessionStorage.removeItem('neova-autogift-removed-' + s.autoGiftVariantId);
        dispatchCartRefresh();
      }
    } catch (e) {
      console.error('[neova-cart] cart gift logic failed', e);
    } finally {
      cartLogicRunning = false;
    }
  }

  // Backward-compat alias for older event hooks
  const runAutogift = runCartGiftLogic;

  document.addEventListener('click', function (evt) {
    const link = evt.target.closest('a[href*="cart/change"]');
    if (!link) return;
    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (e) {
      return;
    }
    const qty = url.searchParams.get('quantity');
    if (qty !== '0') return;

    const lineItem = link.closest('line-item');
    if (!lineItem) return;

    fetchCart().then(function (cart) {
      const s = settings();
      if (!s.autoGiftVariantId) return;
      const giftLine = cart.items.find(function (i) {
        return i.variant_id === s.autoGiftVariantId;
      });
      if (!giftLine) return;
      const lineKey = url.searchParams.get('id');
      if (lineKey === giftLine.key) {
        sessionStorage.setItem('neova-autogift-removed-' + s.autoGiftVariantId, '1');
      }
    });
  });

  document.addEventListener('cart-drawer:refreshed', runAutogift);
  document.addEventListener('cart:change', runAutogift);
  document.addEventListener('DOMContentLoaded', runAutogift);
})();